<template>
  <hic-dialog :visible="visible" title="全文本" @open="open" @close="close" width="50rem" top="4vh">
    <el-descriptions title="">
      <el-descriptions-item label="患者">{{ main.patientName }}</el-descriptions-item>
      <el-descriptions-item label="科室">{{ main.deptCode | dictText("Dept") }}</el-descriptions-item>
      <el-descriptions-item label="医师">{{ main.doctorName }}</el-descriptions-item>
      <el-descriptions-item label="日期">{{ main.opTime | fmtDate }} </el-descriptions-item>
      <el-descriptions-item label="就诊号">{{ main.opNo }}</el-descriptions-item>
    </el-descriptions>
    <el-input v-if="!loading" v-model="txt" placeholder="请输入文本" type="textarea" :rows="25" />
    <el-skeleton :rows="15" v-else animated />

    <template slot="footer">
      <el-button type="warning" @click="extract" :loading="loading" class="pull-left" icon="el-icon-ice-drink">抽取覆盖</el-button>
      <el-button type="info" @click="close">关 闭</el-button>
      <el-button type="primary" @click="send" :loading="sending" icon="el-icon-s-promotion">发送HIS</el-button>
    </template>
  </hic-dialog>
</template>

<script>
  export default {
    props: {
      visible: Boolean,
      main: Object,
    },
    data() {
      return {
        txt: null,
        loading: false,
        sending: false,
      };
    },
    methods: {
      open() {
        this.txt = null
        this.loading = true;
        this.$api.MrMain.text(this.main.id)
          .then((res) => {
            this.txt = res;
          })
          .catch((e) => {
            this.$message.error("查询失败");
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
      send() {
        this.sending = true;
        this.$api.MrMain.send(this.main.id, this.txt)
          .then(() => {
            this.$message.success("发送成功");
            this.close();
          })
          .catch((e) => {
            this.$message.error("发送失败");
            console.log(e);
          })
          .finally(() => {
            this.sending = false;
          });
      },
      extract() {
        this.loading = true;
        this.$api.MrMain.extract(this.main.id)
          .then((res) => {
            this.txt = res;
          })
          .catch((e) => {
            this.$message.error("查询失败");
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
